// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J7vW","icon":"styles_icon__1kQyH"};